import { network } from '@utils'
import { handleReturn } from './root'

interface RealtimeTokenProps {
  slug: string
}

interface RealtimeTokenResponse {
  token: string
}

export const fetchRealtimeToken = async ({
  slug
}: RealtimeTokenProps): Promise<RealtimeTokenResponse> => {
  const { status, data } = await network.httpClient.request({
    url: '/auth/jwt/',
    method: 'POST',
    data: { business_slug: slug },
    validateStatus: () => true
  })

  return handleReturn({ status, data })
}
